import { alpha } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Typography from '@mui/material/Typography'
import Ad from 'components/Ad'
import Layout from 'components/Layout'
import SwiperShows from 'components/SwiperShows'
import { getCategories, getCategory } from 'lib/categories'
import { RANGE_2DAYS, RANGE_7DAYS, SORT_CLICKS, SORT_EXPIRYDATE, SORT_RANKING, TITLE_EXPIRING, TITLE_JUST_ADDED, TITLE_TOP20_2DAYS, TITLE_TOP20_7DAYS } from 'lib/constants'
import { getShows, getShowsInCategory } from 'lib/shows'
import { sortByRemainingHours } from 'lib/utils'
import Head from 'next/head'

const useStyles = makeStyles((theme) => ({
  header: {
    color: 'white',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    width: '100%',
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    '@media (max-width: 687px)': {
      backgroundSize: 'cover'
    }
  },
  icon: {
    fontSize: '50px',
    marginRight: '20px'
  },
  title: {
    textAlign: 'center',
    backgroundColor: alpha(theme.palette.background.default, 0.5),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  '@global': {
    '.ad-categories-leaderboard': {
      marginBottom: theme.spacing(7),
      width: '100%'
    }
  }
}))

export default function Category ({ category, top20days7, top20days2, justAdded, expiring }) {
  const classes = useStyles()
  const title = `Sendung verpasst? ${category.name}: Alle Videos der Rubrik`

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name='description' content={'Alle ' + category.namePlural + ' von ARD, ZDF, RTL, Sat1, Pro7, VOX, Kabel 1 etc. kostenlos abrufen - einfach, schnell und legal'} />
      </Head>
      <Layout header={
        <div className={classes.header} style={{ backgroundImage: 'url("/images/categories/' + category.slug + '.png")' }}>
          <Typography component='h1' variant='h1' className={classes.title} data-test='title'>{category.name}</Typography>
          <div className={classes.titleBg} />
        </div>
        }
      >

        <SwiperShows title={TITLE_TOP20_7DAYS} items={top20days7} counter clicks href={'/search?sort=clicks&cat=' + category.slug} />
        <Ad slot={process.env.NEXT_PUBLIC_ADSENSE_SLOT_CATEGORIES_LEADERBOARD} classname='ad-categories-leaderboard' fullWidth formatAuto key={Math.random()} />
        <SwiperShows title={TITLE_TOP20_2DAYS} items={top20days2} clicks href={'/search?sort=clicks&cat=' + category.slug} />
        <SwiperShows title={TITLE_JUST_ADDED} items={justAdded} href={'/search?sort=date&cat=' + category.slug} />
        <SwiperShows title={TITLE_EXPIRING} items={expiring} expiryDate />

      </Layout>
    </>
  )
}

export async function getStaticPaths () {
  const paths = getCategories().map(category => ({
    params: { slug: category.slug }
  }))

  return {
    paths,
    fallback: false
  }
}

export async function getStaticProps ({ params }) {
  const slug = params.slug
  let category = getCategory(slug)

  if (!category) {
    return { notFound: true }
  }

  // getServerSideProps requires JSON object
  category = category.toJSON()

  const top20days7Result = await getShowsInCategory(slug, RANGE_7DAYS)
  const top20days2Result = await getShows({ sort: SORT_CLICKS, category: category.slug, range: RANGE_2DAYS })
  const justAddedResult = await getShows({ sort: SORT_RANKING, category: category.slug })
  const expiringResult = await getShows({ sort: SORT_EXPIRYDATE, category: category.slug, trailer: false })

  const top20days7 = top20days7Result.hits.hits
  const top20days2 = top20days2Result.hits.hits
  const justAdded = justAddedResult.hits.hits
  const expiring = sortByRemainingHours(expiringResult.hits.hits)

  return {
    props: {
      category,
      top20days7,
      top20days2,
      justAdded,
      expiring
    },
    revalidate: parseInt(process.env.CACHE_CATEGORY)
  }
}
